import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthConfig = () => {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// =====================================================
// GET CONTENT MAIN LIST
// =====================================================

export const getContentMainsApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append("page", payload.page || 1);
    formData.append("limit", payload.limit || 10);
    formData.append("search", payload.search || "");
    formData.append("type", payload.type || "");
    formData.append("parentType", payload.parentType || "");
    formData.append("category", payload.category || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/list`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load main content.",
    };
  }
};

// =====================================================
// CONTENT MAIN STATS
// =====================================================

export const getContentMainStatsApi = async () => {
  try {
    const formData = new FormData();

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/stats`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load content statistics.",
    };
  }
};

// =====================================================
// GET SINGLE CONTENT MAIN
// =====================================================

export const getContentMainApi = async (contentId) => {
  try {
    const formData = new FormData();

    formData.append("con_id", contentId);

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/view`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load content.",
    };
  }
};

// =====================================================
// CREATE CONTENT MAIN
// =====================================================

export const createContentMainApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_parent",
      payload.con_parent ?? ""
    );

    formData.append(
      "con_parent_type",
      payload.con_parent_type || ""
    );

    formData.append(
      "con_title",
      payload.con_title || ""
    );

    formData.append(
      "con_meta_title",
      payload.con_meta_title || ""
    );

    formData.append(
      "con_keyword",
      payload.con_keyword || ""
    );

    formData.append(
      "con_sub_title",
      payload.con_sub_title || ""
    );

    formData.append(
      "con_cat",
      payload.con_cat ?? ""
    );

    formData.append(
      "con_type",
      payload.con_type || ""
    );

    formData.append(
      "con_desc",
      payload.con_desc || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/create`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to create content.",
    };
  }
};

// =====================================================
// UPDATE CONTENT MAIN
// =====================================================

export const updateContentMainApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    formData.append(
      "con_id",
      payload.con_id ?? ""
    );

    formData.append(
      "con_parent",
      payload.con_parent ?? ""
    );

    formData.append(
      "con_parent_type",
      payload.con_parent_type || ""
    );

    formData.append(
      "con_title",
      payload.con_title || ""
    );

    formData.append(
      "con_meta_title",
      payload.con_meta_title || ""
    );

    formData.append(
      "con_keyword",
      payload.con_keyword || ""
    );

    formData.append(
      "con_sub_title",
      payload.con_sub_title || ""
    );

    formData.append(
      "con_cat",
      payload.con_cat ?? ""
    );

    formData.append(
      "con_type",
      payload.con_type || ""
    );

    formData.append(
      "con_desc",
      payload.con_desc || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/update`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to update content.",
    };
  }
};

// =====================================================
// DELETE CONTENT MAIN
// =====================================================

export const deleteContentMainApi = async (contentId) => {
  try {
    const formData = new FormData();

    formData.append("con_id", contentId);

    const res = await axios.post(
      `${apiBaseUrl}admin/content-main/delete`,
      formData,
      getAuthConfig()
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to delete content.",
    };
  }
};